// removed by extract-text-webpack-plugin
module.exports = {"field":"app-xO-Q3ADX"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/charts/Field/index.less
// module id = 612
// module chunks = 0